import React, {useState} from 'react'
import ReactDOM from 'react-dom'
import {Lang} from 'yougile-lang'
import {LinkButton} from '../buttons'
import {Input} from '../input'
import {InputApi} from '../input/types'
import {NotificationPopup} from './notification-popup'
import {useKeyboardInteraction} from './use-keyboard-interaction'

export const showPrompt = async (
  message: string,
  defaultValue = ''
): Promise<string> =>
  new Promise<string>(resolve => {
    const el = document.createElement('div')
    document.body.appendChild(el)
    const close = () => {
      ReactDOM.unmountComponentAtNode(el)
      document.body.removeChild(el)
      resolve('')
    }
    const submit = (value: string) => {
      ReactDOM.unmountComponentAtNode(el)
      document.body.removeChild(el)
      resolve(value)
    }
    ReactDOM.render(
      <Prompt
        message={message}
        close={close}
        submit={submit}
        defaultValue={defaultValue}
      />,
      el
    )
  })

interface Props {
  message: string
  close: () => void
  submit: (value: string) => void
  defaultValue: string
}

const Prompt = (props: Props) => {
  const {message, close, submit, defaultValue} = props
  const [value, setValue] = useState(defaultValue)
  const onChange = (api: InputApi) => setValue(api.text)
  const onSubmit = () => submit(value)

  useKeyboardInteraction({close})

  return (
    <NotificationPopup
      title={Lang.msg.common.prompt}
      icon="IconPrompt"
      content={
        <>
          <div className="text-secondary">{message}</div>
          <div className="mt-8">
            <Input
              autoFocus
              placeholder={Lang.msg.common.enterValue}
              onSubmit={onSubmit}
              onChange={onChange}
            />
          </div>
        </>
      }
      onClose={close}
      buttons={
        <>
          <LinkButton size="small" onClick={onSubmit}>
            {Lang.msg.done}
          </LinkButton>
          <LinkButton color="secondary" size="small" onClick={close}>
            {Lang.msg.cancel}
          </LinkButton>
        </>
      }
    />
  )
}
